(() => {
	document.querySelectorAll('.js-video-poster').forEach(el => {
		el.addEventListener('click', e => {
			e.preventDefault();
			const videoNode = e.target.previousSibling;
			if (videoNode.tagName === 'IFRAME') {
				videoNode.setAttribute('src', videoNode.dataset.src);
				videoNode.parentNode.classList.toggle('video-wrapper-active');
			}
			if (videoNode.tagName === 'VIDEO') {
				videoNode.parentNode.classList.toggle('video-wrapper-active');
				videoNode.play();
			}
		});
	});
})();
